import React from "react";


export function Pagination({pager, setPage}) {
    const items = [];
    if (pager.hasPrevious) {
        items.push(
            <li key={pager.startPage - 1} className="page-item" style={{cursor: "pointer"}}>
                <a className="page-link" onClick={() => setPage(pager.startPage - 1)}>&lt;</a>
            </li>
        )
    }

    for (let i = pager.startPage; i <= pager.endPage; i++) {
        items.push(
            <li key={i} className={"page-item " + (pager.page === i ? 'active' : '')} style={{cursor: "pointer"}}>
                <a className="page-link" onClick={() => setPage(i)}>{i}</a>
            </li>
        )
    }

    if (pager.hasNext) {
        items.push(
            <li key={pager.endPage + 1} className="page-item" style={{cursor: "pointer"}}>
                <a className="page-link" onClick={() => setPage(pager.endPage + 1)}>&gt;</a>
            </li>
        )
    }
    return (
        <div style={{paddingTop: '10px', paddingBottom: '40px'}}>
            <nav aria-label="Contacts Page Navigation">
                <ul className="pagination justify-content-center m-0">
                    {items}
                </ul>
            </nav>
        </div>
    )
}